import React, { useState, useEffect } from 'react';
import { Upload, Button, message, Card, Image, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '../../../config/base'; // Ensure this points to your API configuration

const ImageUpload = ({ sessionname }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch images for the gallery
  const fetchImages = async () => {
    try {
      const response = await api.get(`/upload/images`, { 
        params: { sessionname }  // Send sessionname as query parameter
      });

      if (response.data && response.data.files) {
        setImageUrls(response.data.files);
      } else {
        throw new Error('No images found.');
      }
    } catch (err) {
      setError('Failed to fetch images.');
      console.error(err);
    } finally {
      setGalleryLoading(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, [sessionname]);

  const uploadImages = async (files) => {
    try {
      const formData = new FormData();
      files.forEach(file => formData.append('photos', file));

      const response = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data && response.data.files) {
        return response.data.files;
      } else {
        throw new Error('No URLs returned from upload API');
      }
    } catch (error) {
      console.error('Image upload error:', error);
      message.error('Image upload failed.');
      return []; 
    }
  };

  const handleCustomRequest = async ({ file, onSuccess, onError }) => {
    setLoading(true);
    try {
      const urls = await uploadImages([file]);

      if (urls.length > 0) {
        setImageUrls(prevUrls => [...prevUrls, ...urls]);
        onSuccess({ status: 'done', urls });
        message.success('Images uploaded successfully!');
      } else {
        throw new Error('Failed to retrieve image URLs.');
      }
    } catch (error) {
      onError(error);
      message.error('Image upload failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <Upload
        multiple
        listType="picture-card"
        showUploadList={true}
        customRequest={handleCustomRequest}
      >
        <Button icon={<UploadOutlined />} loading={loading}>
          {loading ? 'Uploading...' : 'Upload Images'}
        </Button>
      </Upload>

      <Card title="Image Gallery" style={{ marginTop: '20px', width: '100%' }}>
        {galleryLoading ? (
          <Spin />
        ) : error ? (
          <p>{error}</p>
        ) : imageUrls.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {imageUrls.map((file, index) => (
              <Image
                key={index}
                width={200}
                src={file.url}
                alt={`Uploaded Image ${index + 1}`}
                style={{ marginBottom: '10px' }}
              />
            ))}
          </div>
        ) : (
          <p>No images found</p>
        )}
      </Card>
    </div>
  );
};

export default ImageUpload;
